import { render, staticRenderFns } from "./OrganisationDetails.vue?vue&type=template&id=1a0f6421&scoped=true"
import script from "./OrganisationDetails.vue?vue&type=script&lang=js"
export * from "./OrganisationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganisationDetails.vue?vue&type=style&index=0&id=1a0f6421&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0f6421",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0f6421')) {
      api.createRecord('1a0f6421', component.options)
    } else {
      api.reload('1a0f6421', component.options)
    }
    module.hot.accept("./OrganisationDetails.vue?vue&type=template&id=1a0f6421&scoped=true", function () {
      api.rerender('1a0f6421', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/OrganisationDetails.vue"
export default component.exports